"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _TicketsPipelinesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStore"));

var parseStage = function parseStage(stage, pipeline) {
  return stage.merge({
    pipelineDisplayOrder: pipeline.get('displayOrder'),
    pipelineId: pipeline.get('pipelineId'),
    pipelineLabel: pipeline.get('label'),
    text: stage.get('label'),
    value: stage.get('stageId')
  });
};

var TicketsPiplinesStagesStore = _generalStore.default.defineFactory().defineName('TicketsPiplinesStagesStore').defineGetInitialState(function () {
  return (0, _immutable.Map)();
}).defineGet(function (state, ticketPipelineStageId) {
  if (state.size === 0) {
    _TicketsPipelinesStore.default.get();
  }

  if (ticketPipelineStageId) {
    return state.get(ticketPipelineStageId);
  }

  return state;
}).defineResponseTo(_ActionTypes.TICKET_PIPELINES_FETCH_SUCCEEDED, function (state, pipelines) {
  pipelines.forEach(function (pipeline) {
    return pipeline.get('stages').forEach(function (stage) {
      state = state.set(stage.get('stageId'), parseStage(stage, pipeline));
    });
  });
  return state;
}).defineResponseTo(_ActionTypes.PIPELINE_UPDATED, function (state, pipeline) {
  var value = pipeline.value;

  if (!value) {
    return state;
  }

  var stages = value.get('stages').sortBy(function (stage) {
    return stage.get('displayOrder');
  });
  stages.forEach(function (stage) {
    state = state.set(stage.get('stageId'), parseStage(stage, value));
  });
  return state;
}).defineResponseTo(_ActionTypes.PIPELINE_DELETED, function (state, pipelineId) {
  return state.filter(function (stage) {
    return stage.get('pipelineId') !== pipelineId;
  });
}).register(_dispatcher.default);

var _default = TicketsPiplinesStagesStore;
exports.default = _default;
module.exports = exports.default;